<template>
  <div class="commonTotalProduceTable">
    <b-table
      :items="totalProduceTimeItem"
      :fields="totalProduceTimeFields"
      sticky-header="447px"
      :no-border-collapse="true"
      class="text-center orderManagement-common-totalProduceTime-table-detail"
    >
      <template #cell(startTime)="data">
        <template v-if="data.value == ''">-</template>
        <template v-else>{{ data.value }}</template>
      </template>
      <template #cell(endTime)="data">
        <template v-if="data.value == ''">-</template>
        <template v-else>{{ data.value }}</template>
      </template>
      <template #cell(device_name)="data">
        <template v-if="modStatus">
          <input
            type="text"
            @blur="checkChangeInput('device_name', data.index)"
            v-model="totalProduceTimeItem[data.index].device_name"
            style="width: 100%;height: 100%;"
            class="text-center"
          />
        </template>
        <template v-else>{{ data.value }}</template>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "commonTotalProduceTable",
  props: {
    processID: {
      type: String
    },
    totalProduceTimeItem: {
      type: Array,
      default: []
    },
    reason: {
      type: Array,
      default: []
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      totalProduceTimeFields: [
        {
          key: "code",
          label: "製程",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "device_name",
          label: "機台編號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "startTime",
          label: "開始時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "endTime",
          label: "結束時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "totalTime",
          label: "生產時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ]
    };
  },
  created: function() {},
  mounted: function() {},
  components: {},
  watch: {},
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal"
    }),
    checkChangeInput(position, index = null) {
      let vm = this;
      switch (position) {
        case "device_name":
          console.log("device_name");
          let device_name = vm.totalProduceTimeItem[index].device_name;
          if (device_name == "" || device_name == undefined) {
            vm.totalProduceTimeItem[index].device_name =
              vm.totalProduceTimeItem[index].orgDevice_name;
            vm.set_alertMsg(`機台編號不可為空，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }
          var params = {};
          params["vuePage"] = vm.selectPage;
          params["methods"] = "POST";
          params["device_name"] = device_name;
          params["whichFunction"] = "checkChangeInput";
          vm.axiosAction(params).then(() => {
            var result = vm.axiosResult;
            if (result["Response"] == "ok") {
              if (vm.processID != result["QueryValueData"]) {
                vm.set_alertMsg(`該製程無此機台編號，請再次確認`);
                vm.settimeout_alertModal();
                vm.totalProduceTimeItem[index].device_name =
                  vm.totalProduceTimeItem[index].orgDevice_name;
                return;
              }
              vm.totalProduceTimeItem[index].orgDevice_name = device_name;

              var queryIndex = vm.totalProduceTimeItem[index].reason.indexOf(
                "device_name"
              );
              if (
                vm.totalProduceTimeItem[index].in_device_name != device_name
              ) {
                if (queryIndex == -1) {
                  vm.totalProduceTimeItem[index].reason.push("device_name");
                }
              } else {
                //舊的跟新的一樣
                if (queryIndex != -1) {
                  vm.totalProduceTimeItem[index].reason.splice(queryIndex, 1);
                }
              }
            } else {
              vm.set_alertMsg(`查無此機台編號，請再次確認`);
              vm.settimeout_alertModal();
              vm.totalProduceTimeItem[index].device_name =
                vm.totalProduceTimeItem[index].orgDevice_name;
              return;
            }
          });
          break;
        default:
          break;
      }
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.orderManagement-common-totalProduceTime-table-detail
  > table
  > thead
  > tr
  > th {
  z-index: 1 !important;
}
.orderManagement-common-totalProduceTime-table-detail th,
.orderManagement-common-totalProduceTime-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.orderManagement-common-totalProduceTime-table-detail td {
  font-size: 1rem;
}
.orderManagement-common-totalProduceTime-table-detail th:first-child,
.orderManagement-common-totalProduceTime-table-detail td:first-child {
  border-left: 1px solid;
}
.orderManagement-common-totalProduceTime-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.orderManagement-common-totalProduceTime-table-detail tr th:nth-child(1),
.orderManagement-common-totalProduceTime-table-detail tr td:nth-child(1) {
  width: 150px;
  min-width: 150px;
}
.orderManagement-common-totalProduceTime-table-detail tr th:nth-child(2),
.orderManagement-common-totalProduceTime-table-detail tr td:nth-child(2) {
  width: 150px;
  min-width: 150px;
}
.orderManagement-common-totalProduceTime-table-detail tr th:nth-child(3),
.orderManagement-common-totalProduceTime-table-detail tr td:nth-child(3) {
  width: 300px;
  min-width: 300px;
}
.orderManagement-common-totalProduceTime-table-detail tr th:nth-child(4),
.orderManagement-common-totalProduceTime-table-detail tr td:nth-child(4) {
  width: 300px;
  min-width: 300px;
}
.orderManagement-common-totalProduceTime-table-detail tr th:nth-child(5),
.orderManagement-common-totalProduceTime-table-detail tr td:nth-child(5) {
  width: 225px;
  min-width: 225px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/table/commonTotalProduceTable.vue